var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"something",on:{"dragover":_vm.dragover,"dragleave":_vm.dragleave,"drop":_vm.drop}})}
var staticRenderFns = []

export { render, staticRenderFns }